import { DateTime, Integer, LocalDateTime } from "neo4j-driver";

import { ConstEnum } from "@abacus/common";

// Requests

export interface CreateAbacusProfileRequest {
  createdBy: string;
  identityId: string;
}

export interface GetProfileByTypeAndIdentityIdRequest {
  identityId: string;
  profileType: string;
}

export interface GetIdentityByEmailRequest {
  email: string;
}

export interface GetIdentityByIdRequest {
  identityId: string;
}

// Responses

export interface HelloResponse {
  status: string;
}

// Entities

export interface Identity {
  active: string;
  defaultBrand: string;
  email: string;
  id: string;
  invitationId: string;
  localization: string;
  name: string;
  numberFormat: string;
  organizationId: string;
  updatedBy: string;
  updatedOn: LocalDateTime;
  userTypes: string[];
}

export interface Profile {
  brand: string;
  createdAt: DateTime;
  createdBy: string;
  fullCatalogAccess: boolean;
  lastModifiedAt: DateTime;
  lastModifiedBy: string;
  profileId: Integer;
  profileName: string;
  profileType: string;
  roles: string[];
  uuid: string;
}

export type ProfileType = ConstEnum<typeof ProfileType>;
export const ProfileType = {
  AbacusProfile: "AbacusProfile",
} as const;
